import { api } from "@/utils/api";

export default class MroRepository {
  async getMROReport(startDate: string, endDate: string, infrastructure: any): Promise<any> {
    const response = await api.post(`mro/report`, { startDate, endDate, infrastructure });
    return response.data;
  }
}
